import { createRedux } from 'src/firebase';
import { Category } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: categoriesReducer,
  docReducer: categoryDetailReducer,
} = createRedux<Category>('categories');

export {
  actions,
  actionTypes,
  categoriesReducer,
  categoryDetailReducer,
};



// WEBPACK FOOTER //
// ./src/categories/redux.ts